var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon"},[_c('div',{staticClass:"icons"},[_c('img',{attrs:{"src":require("@/assets/djxc/icon.png"),"alt":""}}),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])]),(_vm.more)?_c('div',{staticClass:"more",on:{"click":_vm.moreClick}},[_vm._v("\n        "+_vm._s(_vm.moreText)+"\n    ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }